// extracted by mini-css-extract-plugin
module.exports = {"root":"Search_root__1tYGY"};